export class Calendar {
  months: Month[];

  constructor(calendar: Calendar = null) {
    this.months = [];

    if (calendar) {
      Object.assign(this, calendar);
    }
  }
}

export class Month {
  weeks: Week[];
  year: number;
  dateMonth: number;

  constructor(month: Month = null) {
    this.weeks = [];

    if (month) {
      Object.assign(this, month);
    }
  }
}

export class Week {
  days: Day[];
  month: number;

  constructor(week: Week = null) {
    this.days = [];

    if (week) {
      Object.assign(this, week);
    }
  }
}

export class Day {
  dayOfWeek: DayOfWeek;
  dayNumber: number;
  date: Date;
  month: number;
  events: Event[];

  constructor(day: Day = null) {
    this.events = [];
    if (day) {
      if (day.dayOfWeek === 0) {
        day.dayOfWeek = 6;
      } else {
        day.dayOfWeek--;
      }
      Object.assign(this, day);
    }
  }
}

export enum DayOfWeek {
  Monday = 0,
  Tuesday = 1,
  Wendesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6
}

export class Event {
  id: string;
  from: Date;
  to: Date;
  name: string;
  type: ReservationType;

  isStart?: boolean;
  isEnd?: boolean;
  calendarPosition?: number;

  constructor(event: Event = null) {
    if (event) {
      const from = new Date(event.from);
      const to = new Date(event.to);
      this.from = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0, 0);
      this.to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, 0, 0, 0);
      this.id = event.id;
      this.name = event.name;
      this.type = event.type;
      this.isEnd = event.isEnd;
      this.isStart = event.isStart;
      this.calendarPosition = event.calendarPosition;
    }
  }
}

export enum ReservationType {
  EntireVilla = 0,
  Upstairs = 1,
  Downstairs = 2
}
